module.exports = __webpack_public_path__ + "static/media/subGoogle2.be38f4de.png";